// Prep estimates are minutes. Start at receipt, never at acceptance or page load.
export const WARNING_PREP_RATIO = 0.8;

export const parsePrepMinutes = (value) => {
  if (typeof value !== "number" && typeof value !== "string") return null;
  const input = String(value).trim();
  if (!/^\d+(?:\.\d+)?\s*(?:mins?|minutes?)?$/i.test(input)) return null;
  const minutes = parseFloat(input);
  return Number.isFinite(minutes) && minutes > 0 ? minutes : null;
};

export const parseReceivedTime = (value) => {
  if (value == null || value === "") return null;
  if (value instanceof Date || typeof value === "number") {
    const timestamp = Number(value);
    return Number.isFinite(new Date(timestamp).getTime()) ? timestamp : null;
  }
  if (typeof value !== "string" || !value.trim()) return null;
  const input = value.trim().replace(" ", "T");
  // The jobs service also sends UTC timestamps without a zone suffix.
  const zoned = /(?:z|[+-]\d{2}:?\d{2})$/i.test(input);
  const timestamp = Date.parse(!zoned && input.includes("T") ? `${input}Z` : input);
  return Number.isFinite(timestamp) ? timestamp : null;
};

export const formatPrepEstimate = (value) => {
  const minutes = parsePrepMinutes(value);
  return minutes == null ? "N/A" : `${minutes} mins`;
};

export const formatReceivedTime = (value) => {
  const timestamp = parseReceivedTime(value);
  return timestamp == null ? "N/A" : new Date(timestamp).toLocaleTimeString("en-US", {
    hour: "2-digit", minute: "2-digit", hour12: true, timeZone: "Asia/Kolkata",
  });
};

const formatDuration = (seconds) =>
  `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;

export const getOrderTiming = (order, now = Date.now()) => {
  const prepMinutes = parsePrepMinutes(order?.prepTime);
  const received = parseReceivedTime(order?.created);
  if (prepMinutes == null || received == null || !Number.isFinite(now)) {
    return {
      tone: "neutral",
      label: "Timer unavailable",
      display: "—",
      description: prepMinutes == null ? "No valid prep estimate." : "Received time unavailable.",
      prepMinutes,
    };
  }
  const duration = prepMinutes * 60000;
  const elapsed = Math.max(0, now - received);
  const remaining = duration - elapsed;
  const tone = remaining <= 0 ? "red" : elapsed >= duration * WARNING_PREP_RATIO ? "orange" : "green";
  const seconds = remaining <= 0 ? Math.floor(-remaining / 1000) : Math.ceil(remaining / 1000);
  return {
    tone,
    label: remaining <= 0 ? "Overdue by" : "Complete within",
    display: formatDuration(seconds),
    description: tone === "red" ? "Prep time exceeded · min:sec"
      : tone === "orange" ? "Due soon · min:sec"
      : "On time · min:sec",
    prepMinutes,
  };
};
